(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["registro-garantia-estendida"] && !window.DesignMode) return;
  try {
    

var api_url = 'https://api-frete.vercel.app'
var api_url_register = 'https://api.elements.com.br'

// aqui vai o codigo das estrelas
const stars = document.querySelectorAll('.star')
const star_value = document.querySelector('.star_value')
stars.forEach((star,index)=>{
    star.addEventListener('click',()=>{
    let current_star_level = index + 1
        star_value.value = current_star_level
        stars.forEach((star2, index2)=>{
            if(current_star_level >= index2 + 1){
                star2.innerHTML = '&#9733;'
            }else{
                star2.innerHTML = '&#9734;'
            }
        })
    
    })
})

// Essa function é responsavel para pesquisar os produtos
const produtos = document.querySelector('#produtos');
const searchResult = document.querySelector('.search_result');

async function getOrder(value) {
    const response = await fetch(`${api_url}/products`, { method: "POST" });
    const result = await response.json();
    const filteredProducts = result.filter(product =>
    product.title.toLowerCase().includes(value.toLowerCase()) &&
    !product.title.toLowerCase().includes('open box')
    ); 
 
    let template = '';
    if (filteredProducts.length > 0) {
        template = filteredProducts.map(product => `<div data-name="${product.title}" class="getName">${product.title}</div>`).join('');
    } else {
        template = `<div>Produto não encontrado!</div>`;
    }
    searchResult.innerHTML = template;
}

function selectProduct(productName) {
    produtos.value = productName;
    searchResult.classList.add('hideNone');
}

searchResult.addEventListener("click", (event) => {
    const target = event.target;
    if (target.classList.contains('getName')) {
        selectProduct(target.dataset.name);
    }
});

produtos.addEventListener("input", async(event) => {
    await getOrder(produtos.value);
});


// aqui vai o codigo para btn de cancelar
var btn_cancelar = document.querySelector('.btn_cancelar')

function canceledForm(){
    sessionStorage.removeItem('email_customer_no_register')
    sessionStorage.removeItem('email_customer_yes_register')
    sessionStorage.removeItem('email_customer_not_register_2')
    sessionStorage.removeItem('newCustomerEmail')
    sessionStorage.removeItem('orderId')
    sessionStorage.removeItem('newCustomerName')
    sessionStorage.removeItem('email_customer_register')
    sessionStorage.removeItem('maketplace');
}

btn_cancelar.addEventListener("click", (e) =>{
    canceledForm()
})

// Essa function é responsavel para escolher as lojas

async function getStore(store){
    document.querySelector('.number_order').value=''
    document.querySelector('.btn_registrar_cadastrado').style.display="block"
    var pedido = document.querySelector('.pedido')
    var fiscal = document.querySelector('.fiscal')
    var fiscalImg = document.querySelector('.fiscalImg')
    var produtoNome = document.querySelector('.produto_nome')
    var qty = document.querySelector('.qty')
    if(store == 'Elements'){
     elementsStore(pedido,fiscal,fiscalImg,produtoNome,qty)
    }else{
      otherStore(pedido,fiscal,fiscalImg,produtoNome,qty)
    }
}

function otherStore(pedido,fiscal,fiscalImg,produtoNome,qty){
    fiscal.classList.add('showBlock')
    fiscalImg.classList.add('showBlock')
    produtoNome.classList.add('showBlock')
    qty.classList.add('showBlock')
    pedido.classList.add('hideNone')
    pedido.classList.remove('showBlock')
    fiscal.classList.remove('hideNone')
    fiscalImg.classList.remove('hideNone')
    produtoNome.classList.remove('hideNone')
    qty.classList.remove('hideNone')
    sessionStorage.setItem('maketplace', 'maketplace');
}

function elementsStore(pedido,fiscal,fiscalImg,produtoNome,qty){
    fiscal.classList.add('hideNone')
    fiscalImg.classList.add('hideNone')
    produtoNome.classList.add('hideNone')
    qty.classList.add('hideNone')
    fiscal.classList.remove('showBlock')
    fiscalImg.classList.remove('showBlock')
    produtoNome.classList.remove('showBlock')
    qty.classList.remove('showBlock')
    pedido.classList.add('showBlock')
    pedido.classList.remove('hideNone')
    sessionStorage.removeItem('maketplace');
}

var webSite = document.querySelector('#web-sites')
webSite.addEventListener('change', async(e)=>{
    var store = e.target.value
     await getStore(store)
})

//
  
function customer_not_regiter(email){
    sessionStorage.removeItem('orderId')
    sessionStorage.removeItem('email_customer_yes_register');
    sessionStorage.setItem('newCustomerEmail', email);
    sessionStorage.setItem('maketplace', 'maketplace');
    window.location.href = '/pages/register';
}

  //verificar se o cliente tem cadastro no site.

  async function customer_register_not_order(email){
    try {
        const response = await fetch(`${api_url}/customer/${email}`,{method: "POST"})
        const result = await response.json()
        const getCustomer = await getCustomerAppHiko(email)

        if(result.length > 0 && result[0].first_name && result[0].last_name){
          return customer_contains_account(result)
        }
        if(getCustomer?.google){
            var data =[
               {
                first_name: getCustomer.google.first_name,
                last_name: getCustomer.google.last_name ?? getCustomer.google.first_name,
                email: email
               }
            ]
          return customer_contains_account(data)
        }

        customer_not_regiter(email)
        
     } catch (error) {
        console.log(error)
     }
}

async function getCustomerAppHiko(email){
    const response = await fetch(`https://customer-hiko.vercel.app/customer/${email}`)
    const result = await response.json()
    return result
}

function customer_contains_account(info){
  console.log(info)
    var email = info[0].email
    sessionStorage.removeItem('orderId')
    sessionStorage.removeItem('email_customer_not_register_2');
    sessionStorage.removeItem('email_customer_no_register');
    sessionStorage.setItem('email_customer_register', JSON.stringify(info[0]));
    sessionStorage.setItem('email_customer_yes_register', 'yes_register');
    sessionStorage.setItem('maketplace', 'maketplace');
    sessionStorage.setItem('newCustomerEmail', email);
    //sessionStorage.setItem('newCustomerName', info[0].first_name + " " + info[0].last_name);
    window.location.reload();
}

function customer_regiter_contains_order(data){
    var email = data[0].email
    sessionStorage.removeItem('orderId')
    sessionStorage.removeItem('email_customer_not_register_2');
    sessionStorage.removeItem('email_customer_no_register');
    sessionStorage.setItem('email_customer_register', JSON.stringify(data[0]));
    sessionStorage.setItem('email_customer_yes_register', 'yes_register');
    sessionStorage.setItem('maketplace', "maketplace");
    sessionStorage.setItem('newCustomerEmail', email);
    sessionStorage.setItem('newCustomerName', data[0].shipping_address.first_name + " " + data[0].shipping_address.last_name);
    window.location.reload();
}

async function customer_contains_order(email){
    try {
       const response = await fetch(`${api_url}/order/${email}`,{method: "POST"})
        const result = await response.json()

        if(result.length > 0){
          customer_regiter_contains_order(result)
        }else{
          await customer_register_not_order(email)
        }
   } catch (error) {
      console.log(error)
   }
}

var btnGarantia = document.querySelector('.btn_garantia')
btnGarantia.addEventListener('click', async(e)=>{
    e.preventDefault()
    var emailGarantia = document.querySelector('.email_garantia')
    var email = emailGarantia.value
    if(emailGarantia.value === ""){
        alert("Preencha o campo do email")
    }else{
        document.querySelector('.loader_garantia_base').classList.remove('hideLoader')
       await customer_contains_order(email)
    }
})

function sessionStorageItem(){
    var customer = sessionStorage.getItem('email_customer_yes_register');
    var customerData = sessionStorage.getItem('email_customer_register');
    var data =JSON.parse(customerData)
    var name = data ? data?.first_name +" "+ data?.last_name:null
    var email = sessionStorage.getItem('newCustomerEmail');
    var orderId = JSON.parse(sessionStorage.getItem('orderId'));
    var order = JSON.parse(sessionStorage.getItem('order'));
    const newcustomer = sessionStorage.getItem('newCustomerName');
    return { email, customer,name,data, orderId, order,newcustomer}
}

const customerDataExist =sessionStorageItem()

if(customerDataExist.email){
  document.querySelector('.form_email_base').style.display="block"
}
if(customerDataExist.customer || customerDataExist.newcustomer){
    document.querySelector('.cadastrado').style.display="flex"
    document.querySelector('.form_email_base').style.display="none";
}

if(customerDataExist.name || customerDataExist.newcustomer) {
  document.querySelector('.cadastrado').style.display="flex"
  document.querySelector('.form_email_base').style.display="none";
  document.querySelector('.check_email').innerHTML=customerDataExist.email
  document.querySelector('.check_name').innerHTML=customerDataExist.name
}

// aqui vai o codigo para fazer o cadastro

function sucess_remove(){
    document.getElementById('garantia_spinner').style.display="none"
    document.getElementById("form_garantia_cadastrada").reset()
    document.querySelector(".register_sucess").style.display="block"
    sessionStorage.removeItem('orderId')
    sessionStorage.removeItem('email_customer_register')
    sessionStorage.removeItem('email_customer_not_register_2')
    sessionStorage.removeItem('email_customer_no_register');
    sessionStorage.removeItem('email_customer_yes_register');
    sessionStorage.removeItem('newCustomer')
    document.getElementById("form_garantia_cadastrada").style.display="none"
    sessionStorage.removeItem('maketplace');
    sessionStorage.removeItem('newCustomerName')
}

function showError(response){
  alert(response)
  window.location.reload();
}

function formError(response){
   if (response == "fiscal exist"){
    showError('Nota fiscal já foi cadastrada!')   
    }else if (response == "serial exist"){
      showError('Número serial já foi cadastrado!')
    }else if ( response =='Falha ao enviar arquivo'|| response == "Falha ao enviar arquivo" || response == "Arquivo muito grande! Max: 2MB" || response == "Tipo de arquivo não aceito! Válido: jpeg, jpg, pdf, png" ){
     showError(response)
    }else if (response == "order exist"){
    showError('Número pedido já foi cadastrado!')
    }else{
     showError('Parece que houve um erro no cadastro da garantia. Vamos tentar novamente. Por favor')
    }
}
async function registerElements(formData){
        if(formData.get('pedido') == ''){
           alert('Número de pedido é obrigatório')
        }else if(formData.get('serial') == ''){
           alert('Número de serial é obrigatório')
        }else if(formData.get('social') == ''){
           alert('Rede social é obrigatório')
        }else if(formData.get('link') == ''){
           alert('Link é obrigatório')
        }else if(formData.get('rate') == ''){
           alert('Avaliação é obrigatório')
        }else if(formData.get('pedido') == ''){
           alert('Número de pedido é obrigatório')
        }else if(formData.get('serial') == ''){
            alert('Número de serial é obrigatório')
        }else if(formData.get('social') == ''){
           alert('Rede social é obrigatório')
        }else if(formData.get('link') == ''){
           alert('Link é obrigatório')
        }else if(formData.get('rate') == ''){
           alert('Avaliação é obrigatório')
        }else{
            document.getElementById('garantia_spinner').style.display="grid"
            await registerData(formData)
        }
}

async function registerOuther(formData){
    if(formData.get('serial') == ''){
    alert('Número de serial é obrigatório')
    }else if(formData.get('produto') == ''){
    alert('Nome do produto é obrigatório')
    }else if(formData.get('social') == ''){
    alert('Rede social é obrigatório')
    }else if(formData.get('fiscal') == ''){
    alert('Número de nota fiscal é obrigatório')
    }else if(formData.get('arquivo') == ''){
    alert('Arquivo é obrigatório')
    }else if(formData.get('link') == ''){
    alert('Link é obrigatório')
    }else if(formData.get('rate') == ''){
    alert('Avaliação é obrigatório')
    }else{
        document.getElementById('garantia_spinner').style.display="grid"
       await registerData(formData)
    }
}

var btn_registrar_cadastrado = document.querySelector('.btn_registrar_cadastrado')
var numero = document.querySelector('.number_order')
async function registerData(formData){
    const response = await fetch(`${api_url_register}/adiciona-action.php`, {
        method: "POST",
        body: formData
    })
    const result = await response.json()
    if(result.status == 200 && result.msg == 'success') {
        sucess_remove()
    }else if (result.status == 500) {
    document.getElementById('garantia_spinner').style.display="none"
        formError(result.msg)
    }
}

const formSubmit = document.getElementById('form_garantia_cadastrada')
function requiredForm() {
    var fiscal = document.querySelector('.fiscal')
    var fiscalImg = document.querySelector('.fiscalImg')
    var produtoNome = document.querySelector('.produto_nome')
    fiscal.required = true
    fiscalImg.required = true
    produtoNome.required = true
}

if(customerDataExist.email){
    formSubmit.addEventListener("submit", async(e) => {
         e.preventDefault()
         const customer_full_name =document.querySelector('.check_name').innerHTML
         const formData = new FormData(document.getElementById("form_garantia_cadastrada"))
         if(customerDataExist.name && customerDataExist.customer == null){
            formData.append('nome', customer_full_name)
            formData.append('email', customerDataExist.email)
           requiredForm()
         }else {
            formData.append('nome', customer_full_name)
            formData.append('email', customerDataExist.email)
            if(customerDataExist.orderId){
              formData.append('pedido', customerDataExist.orderId)
            }
         }
         if(formData.get('website') == null){
            alert('website é obrigatório')
         }else if(formData.get('website') == 'Elements'){
             const inputVerifyLength = inputVerify(formData)
             if(inputVerifyLength.status == 200){
                await registerElements(formData)
             }else{
                inputVerifyError(inputVerifyLength.msg)
             }
         }else{
            const inputVerifyLengthOther = inputVerify(formData)
            if(inputVerifyLengthOther.status == 200){      
            await registerOuther(formData)
            }else{
               inputVerifyError(inputVerifyLengthOther.msg)
            }
         }

    });
}else{
    formSubmit.addEventListener("submit", async(e) =>{
        e.preventDefault()
        alert('Parece que houve um erro no cadastro da garantia. Vamos tentar novamente. Por favor')
    })
}

function inputVerifyError(response){
   alert(response)
   window.location.reload();
}
function inputVerify(formData){
    if(formData.get('pedido').length > 10){
        return { status: 500, msg: 'Número pedido está muito longo.' }
    }
    if(formData.get('serial').length > 30){
      return { status: 500, msg: 'Número serial está muito longo.' }
    }
    if(formData.get('link').length > 350){
      return { status: 500, msg: 'Link está muito longo.' }
    }
    if(formData.get('link').length < 20){
      return { status: 500, msg: 'Link está muito curto.' }
    }
    if(formData.get('produto').length > 100){
      return { status: 500, msg: 'O nome do produto está muito longo.' }
    }
    return { status: 200, msg: 'success' }
}

// verificar se o clientes tem pedidos

async function customerOrderExist() {
    if(customerDataExist.email){
     try {
          const response = await fetch(`${api_url}/order/${customerDataExist.email}`,{method: "POST"})
          const result = await response.json()
          sessionStorage.setItem('list_orders', JSON.stringify(result))
      } catch (error) {
        console.log(error)
      }
    }else{
         sessionStorage.setItem('list_orders', [])
    }
}

customerOrderExist()

function filterNumero(e){
    var list_orders_active = JSON.parse(sessionStorage.getItem('list_orders') || '[]')
    if(list_orders_active.error){
        document.querySelector('.error_number').style.display="block"
        document.querySelector('.error_number').innerHTML="Não existe pedido com seu e-mail."
        btn_registrar_cadastrado.style.display="none"

    }else{
        var order = list_orders_active.find(es => es.order_number == Number(numero.value))
        if(order){
        btn_registrar_cadastrado.style.display="block"
        sessionStorage.setItem('orderId', JSON.stringify(order.order_number));
        sessionStorage.setItem('order', JSON.stringify(order));
        var orderId = JSON.parse(sessionStorage.getItem('orderId'));
        numero.value= orderId
        document.querySelector('.error_number').innerHTML="Número de pedido válido."
        document.querySelector('.error_number').style.color="green"
        window.location.reload();
        }else{
        document.querySelector('.error_number').innerHTML="Por favor, Digite um número de pedido válido."
        document.querySelector('.error_number').style.display="block"
        document.querySelector('.error_number').style.color="red"
       }
    }
}


numero.addEventListener('focusout',(e)=>{
     filterNumero(e)
})
numero.addEventListener('keyup',(e)=>{
   filterNumero(e)
})

// Essa function é responsavel para aplicar o id do pedido no input
function applyOrderIdToInput(){
    if(customerDataExist.orderId){
      numero.value = customerDataExist.orderId
      document.querySelector('.pedido').style.display="block"
      webSite.value="Elements"
    }
}
applyOrderIdToInput()
function addInfoCustomerToLabel(){
    if(customerDataExist.email && customerDataExist.name !== "undefined undefined"){
        document.querySelector('.check_email').innerHTML=customerDataExist.email
        document.querySelector('.check_name').innerHTML=customerDataExist.name
    }else {
      document.querySelector('.check_email').innerHTML=customerDataExist.email
      document.querySelector('.check_name').innerHTML= customerDataExist.newcustomer
    }

    if(sessionStorage.getItem('newCustomerName')){
        document.querySelector('.check_name').innerHTML= sessionStorage.getItem('newCustomerName')
    }
}
addInfoCustomerToLabel()
var logo_click = document.querySelector('.header__heading-link')
logo_click.addEventListener("click", (e) =>{
   canceledForm()
})


  } catch(e) { console.error(e); }
})();
})();
